(ns common.content-function.core
  (:require [clojure.walk :as walk]
            [com.rpl.specter :as s]
            [lemonpi.content-function.shared.macro :as m]))

(def ASSIGNMENTS
  "Navigate to all assignments."
  [:rules s/ALL :assignments s/ALL])

(def PREDICATES
  "Navigate to all predicates."
  [:rules s/ALL :predicate])

(def EXPRESSIONS
  "Navigate to all expressions."
  [ASSIGNMENTS :expr])

(def EXPRESSION_MACROS
  "Navigate to all context-macros in expressions."
  [EXPRESSIONS
   string?
   (s/parser m/parse-macro-expr m/serialize-macro-expr)
   s/ALL
   m/macro?])

(def PREDICATES_RULES
  [PREDICATES
   vector?
   (s/if-path
    #(= "and" (first %))
    [(s/srange-dynamic (constantly 1) count) s/ALL]
    s/STAY)])

(def PREDICATE_MACROS
  "Navigate to all context-macros in predicates."
  [PREDICATES_RULES
   (s/nthpath 1)
   (s/parser m/parse-macro m/serialize-macro)])

(def MACROS
  "Navigate to all context-macros used in content-function."
  (s/multi-path EXPRESSION_MACROS PREDICATE_MACROS))

(defn get-asset-names
  [cfn-data]
  (set (s/select [:data :placeholders s/ALL
                  #(#{"video" "image" "audio"} (:type %)) :name]
                 cfn-data)))

(defn ->payload
  [cfn-data]
  (let [asset-names (get-asset-names cfn-data)
        ASSET-ASSIGNMENTS [:data ASSIGNMENTS
                           (fn [assignment]
                             (and (contains? asset-names (:name assignment))
                                  (instance? js/File (:expr assignment))))]
        json (->> cfn-data
                  (s/transform [ASSET-ASSIGNMENTS]
                               #(assoc % :expr (str "part://" (:name %))))
                  clj->js
                  (.stringify js/JSON))]
    (-> (reduce (fn [body assignment]
                  (assoc body (:name assignment) (:expr assignment)))
                {}
                (s/select [ASSET-ASSIGNMENTS] cfn-data))
        (assoc :json json))))

(defn add-default-aliases
  [cfn schemas]
  (let [remove-context-split-testing (partial remove #(= "split-testing" (:alias %)))
        default-ctx (->> schemas
                         (remove #(and (= (get-in % [:meta :parameter]) "required")
                                       (not= (get-in % [:meta :id]) "urn:lemonpi:schema:context:split-testing:v1")))
                         (map #(hash-map :schema (get-in % [:meta :id])
                                         :alias (get-in % [:meta :alias]))))]
    (update cfn
            :data
            #(-> %
                 (update :context (partial filter :param))
                 (update :context remove-context-split-testing)
                 (update :context concat default-ctx)
                 (update :context (fn [context]
                                    (if (some (comp (partial = "custom") :alias) context)
                                      (map (fn [{:keys [alias] :as ctx}]
                                             (cond-> ctx
                                               (= alias "custom")
                                               (assoc :param [] :schema "urn:lemonpi:schema:context:custom:v1"))) context)
                                      (conj context {:alias "custom" :param [] :schema "urn:lemonpi:schema:context:custom:v1"}))))
                 (update :context vec)))))

(defn template-placeholders
  [templates template-revision-ids]
  (s/select
   [:value s/ALL :latestRevision #(contains? (set template-revision-ids) (:id %)) :placeholders]
   templates))

(defn keywordify [cfn]
  (walk/postwalk
   (fn [node]
     (cond
       ;; update split testing type
       (and (map? node) (= (:schema node) "urn:lemonpi:schema:context:split-testing:v2"))
       (update-in node [:param :type] keyword)

       ;; update placeholder types, incl collection structure
       (and (map-entry? node) (contains? #{:placeholders :structure} (key node)))
       [(key node) (mapv #(update % :type keyword) (val node))]

       ;; update the dependencies to be sets instead of vectors
       (and (map-entry? node) (= (key node) :dependencies))
       [:dependencies (set (val node))]

       ;; update predicate operators
       (and (map-entry? node) (= (key node) :predicate))
       [:predicate (let [predicate (val node)
                         update-operator #(update % 0 keyword)]
                     (cond
                       (and (sequential? predicate) (= (first predicate) "and"))
                       (into [:and] (map update-operator) (rest predicate))
                       (vector? predicate) (update-operator predicate)
                       :else predicate))]

       :else node))
   cfn))
